const getLanguageSubtag = (languageTag) => languageTag.includes('-') ? languageTag.substring(languageTag.indexOf('-')) : languageTag;
// TODO: this needs tested on some browsers -- specifically IE ><. consider this guy: https://www.npmjs.com/package/url-polyfill
// the /customer... path makes the url ...com//customer... I think this is because the path name is after the domain/etc and already includes the forward slash. I removed it but didn't test it
export const getSupportUrl = (languageTag, article, params) => {
    const supportUrl = new URL('https://help.overdrive.com');
    const language = getLanguageSubtag(languageTag ?? 'en').toLowerCase();
    if (language === 'fr') {
        supportUrl.pathname = `customer/fr/portal/articles/${article ?? ''}`;
    }
    else if (!!article) {
        supportUrl.pathname = `customer/portal/articles/${article ?? ''}`;
    }
    if (params?.libraryKey) {
        supportUrl.searchParams.append('Key', params.libraryKey);
    }
    if (params?.librarySupportUrl) {
        supportUrl.searchParams.append('Sup', params.librarySupportUrl);
    }
    if (params?.isEdge) {
        supportUrl.searchParams.append('edge', 'true');
    }
    return supportUrl.toString();
};
